<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>クライアント情報の編集</v-card-title>
      <v-card-text>
          <v-layout row wrap>
            <v-flex md3>
              <v-text-field v-model="value.id"  label="ID" required :disabled="action == 'update'"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md3>
              <v-text-field v-model="value.name"  label="顧客名" required></v-text-field>
            </v-flex>
          </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">キャンセル</v-btn>
        <v-btn v-if="action == 'add'" @click="addItem">追加</v-btn>
        <v-btn v-if="action == 'update'" @click="updateItem">更新</v-btn>
      </v-card-actions>
    </v-card>

  </div>
</template>

<script>

export default {
  components: {
  },
  props: [
    'value', 'action'
  ],
  data() {
    return {}
  },
  watch: {
  },
  computed: {
  },
  methods: {
    close() {
      this.$emit('closeDialog')
    },
    addItem() {
      this.$emit('createItem')
    },
    updateItem() {
      this.$emit('updateItem')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>